/* eslint-disable jsx-a11y/no-access-key */
import React, {memo} from "react";
import PropTypes from "prop-types";
import {Row} from "reactstrap";
import InputCreator from "./components/InputCreator";
import ToggleCreator from "./components/ToggleCreator";
import SelectCreator from "./components/SelectCreator";
import TimeCreator from "./components/TimeCreator";

const typeMapping = {
  decimal: "number",
  email: "email",
  ip: "text",
  number: "number",
  password: "password",
  text: "text",
  url: "url",
};

const AutoFormGenerator = (props) => {
  const {formArray, title, inputChangeHandler} = props;
  const handleInputChange = (event) => {
    inputChangeHandler(event);
  };

  const fieldCreator = (eachInput) => {
    let {
      field_type,
      field_value,
      field_name,
      field_placeholder,
      field_choices,
      field_is_required,
      field_is_read_only,
      field_helptext,
      field_order,
      slug,
    } = eachInput;
    const fieldKey = `${title}-${slug}`;

    let field;
    switch (field_type) {
      case "toggle":
        field = (
          <ToggleCreator
            id={title}
            accessKey={field_order}
            label={field_name}
            placeholder={field_placeholder}
            checked={field_value}
            name={slug}
            help_text={field_helptext}
            onChange={handleInputChange}
            key={fieldKey}
            testId={slug}
            disabled={field_is_read_only}
          />
        );
        break;

      case "time":
        field = (
          <TimeCreator
            label={field_name}
            value={field_value}
            onChange={handleInputChange}
            accessKey={field_order}
            id={title}
            name={slug}
            key={fieldKey}
            help_text={field_helptext}
            isRequired={field_is_required}
            data-cy={slug}
            disabled={field_is_read_only}
          />
        );
        break;

      case "dropdown":
        field = (
          <SelectCreator
            id={slug}
            classNamePrefix={slug}
            accessKey={field_order}
            label={field_name}
            placeholder={field_placeholder}
            value={field_value}
            name={slug}
            options={field_choices}
            isRequired={field_is_required}
            help_text={field_helptext}
            onChange={handleInputChange}
            isSearchable
            key={fieldKey}
            isDisabled={field_is_read_only}
            data-cy={slug}
          />
        );
        break;

      case "input":
      case "output":
      case "analog_output":
      case "digital_output":
      case "power_channel":
        field = (
          <SelectCreator
            id={slug}
            classNamePrefix={slug}
            accessKey={field_order}
            label={field_name}
            placeholder={field_placeholder}
            value={field_value}
            name={slug}
            options={field_choices}
            isRequired={field_is_required}
            help_text={field_helptext}
            onChange={handleInputChange}
            isSearchable
            key={fieldKey}
            isDisabled={field_is_read_only}
            data-cy={slug}
            isClearable={!field_is_required}
          />
        );
        break;

      case "email":
      case "decimal":
      case "ip":
      case "number":
      case "password":
      case "text":
      case "url":
        field = (
          <InputCreator
            id={title}
            accessKey={field_order}
            label={field_name}
            label_for={slug}
            placeholder={field_placeholder}
            type={typeMapping[field_type] || "text"}
            value={field_value}
            name={slug}
            isRequired={field_is_required}
            help_text={field_helptext}
            onChange={handleInputChange}
            disabled={field_is_read_only}
            key={fieldKey}
            data-cy={slug}
          />
        );
        break;

      case "multiselect":
      case "dow":
      case "dom":
      case "alobm":
      case "dlobm":
        field = (
          <SelectCreator
            id={slug}
            classNamePrefix={slug}
            accessKey={field_order}
            label={field_name}
            placeholder={field_placeholder}
            value={field_value}
            name={slug}
            options={field_choices}
            isRequired={field_is_required}
            help_text={field_helptext}
            onChange={handleInputChange}
            key={fieldKey}
            data-cy={slug}
            isMulti
            isSearchable
            isDisabled={field_is_read_only}
            isClearable={!field_is_required}
          />
        );
        break;

      default:
        field = (
          <InputCreator
            id={title}
            accessKey={field_order}
            label={field_name}
            label_for={slug}
            placeholder={field_placeholder}
            //If switch fall through , let give back default field as text Input
            type={"text"}
            value={field_value}
            isRequired={field_is_required}
            name={slug}
            help_text={field_helptext}
            onChange={handleInputChange}
            disabled={field_is_read_only}
            key={fieldKey}
            data-cy={slug}
          />
        );
        break;
    }
    return field;
  };
  return (
    <div className="pl-lg-4">
      <Row>
        {formArray.map((eachInput) => {
          return fieldCreator(eachInput);
        })}
      </Row>
    </div>
  );
};

AutoFormGenerator.propTypes = {
  formArray: PropTypes.array,
  title: PropTypes.string.isRequired,
  inputChangeHandler: PropTypes.func.isRequired,
};

export default memo(AutoFormGenerator);
